import React, { useEffect, useState } from "react";
import Body from "src/components/common/Body";
import Button from "src/components/common/Button";
import InputFile from "src/components/common/InputFile";
import Textarea from "src/components/common/Textarea";
import styled from "styled-components";
import { useAddReportMutation, useReportDetailQuery, useUpdateReportMutation } from "src/api/reportAPI";
import { getPathValue } from "src/utils/queryStringUtil";
import { useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { addReportRegisterIng } from "src/store/reducers/asReduce";
import { createBrowserHistory } from "history";

function reportRegister() {
  // ===================================================================
  // 기본 세팅 영역
  // ===================================================================
  const as_index: any = getPathValue();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cHisotry = createBrowserHistory();

  // ===================================================================
  // 초기 값 세팅
  // ===================================================================
  const [propsData, setPropsData] = useState<any>([]);

  const [inputs, setInputs] = useState({
    contents: "",
    images: [],
  });

  const [IorU, setIorU] = useState(false);

  const { contents, images } = inputs;

  // 기존 이미지 삭제를 담는 배열
  const [imageIndexData, setImageIndexData] = useState<any>([]);

  const [clickRegisterBtn, setClickRegisterBtn] = useState<boolean>(false);

  // ===================================================================
  // API 영역
  // ===================================================================
  const [insertReport, { isError, isSuccess, isLoading, error }] = useAddReportMutation();

  const [updateReport, { isError: updateIsError, isSuccess: updateIsSuccess, isLoading: updateIsLoading }] = useUpdateReportMutation();

  const reportDetailAPI = useReportDetailQuery(as_index);

  const handleTextarea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value, id } = e.target;
    setInputs({
      ...inputs,
      [id]: value,
    });
  };

  // ===================================================================
  // hook 영역
  // ===================================================================
  useEffect(() => {
    const backEvent = () => {
      if (clickRegisterBtn) {
        dispatch(addReportRegisterIng(true));
      }
    };
    const unlistenHistoryEvent = cHisotry.listen(({ action }) => {
      if (action === "POP") {
        backEvent();
      }
    });
    return unlistenHistoryEvent;
  }, [clickRegisterBtn]);

  useEffect(() => {
    if (reportDetailAPI.isSuccess) {
      if (reportDetailAPI.data.progress !== "ASC_10") {
        setIorU(true);
      }
      setInputs({
        ...inputs,
        contents: reportDetailAPI.data.completion_contents,
        images: reportDetailAPI.data.images,
      });
    }
  }, [reportDetailAPI]);

  useEffect(() => {
    if (isSuccess) {
      navigate("/as-detail/" + as_index, { replace: true });
    }
    if (isError) {
      alert("서버 장애");
      console.log(error);
    }
  }, [isSuccess, isError]);

  useEffect(() => {
    if (updateIsSuccess) {
      navigate("/as-detail/" + as_index, { replace: true });
    }
    if (updateIsError) {
      alert("서버 장애");
    }
  }, [updateIsSuccess, updateIsError]);

  // ===================================================================
  // 클릭 이벤트 영역
  // ===================================================================
  const reportRegiste = async () => {
    if (IorU) {
      const form = new FormData();
      form.append("as_idx", as_index);
      contents && form.append("completion_contents", contents);

      if (imageIndexData.length >= images.length && propsData.length <= 0) {
        alert("이미지를 등록해 주세요");
        return;
      }

      for (let i = 0; i < imageIndexData.length; i++) {
        form.append("delete_imgs", imageIndexData[i].img_idx);
      }

      for (let i = 0; i < propsData.length; i++) {
        form.append("images", propsData[i]);
      }
      updateReport(form);
    } else {
      if (propsData.length < 0) {
        alert("이미지를 등록해 주세요");
        return;
      }
      const fd = new FormData();
      fd.append("as_idx", as_index);
      contents && fd.append("completion_contents", contents);
      for (let i = 0; i < propsData.length; i++) {
        fd.append("images", propsData[i]);
      }
      await insertReport(fd);
    }
    setClickRegisterBtn(true);
  };

  const historyBackBtn = (history: number) => {
    //
    console.log(clickRegisterBtn);
    if (clickRegisterBtn) {
      console.log("clickc``````");
      dispatch(addReportRegisterIng(true));
    }
    navigate(history);
  };

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => historyBackBtn(-1)}>
            완료보고
          </Button>
        </div>
        <div className="btn-box">
          {isLoading ? (
            <p style={{ textAlign: "center" }}>
              <RotatingLines width="20" strokeColor="#00263e" strokeWidth="1" />
            </p>
          ) : updateIsLoading ? (
            <p style={{ textAlign: "center" }}>
              <RotatingLines width="20" strokeColor="#00263e" strokeWidth="1" />
            </p>
          ) : (
            <Button variant="text" onClick={() => reportRegiste()}>
              {IorU ? "수정" : "등록"}
            </Button>
          )}
        </div>
      </header>

      <Body type="datail">
        <TitleBox>
          {/* <p className="title">TODO</p>
          <p className="date">TODO</p> */}
        </TitleBox>

        <WriteWrap>
          <InputFile className="input-file" setPropsData={setPropsData} registeredImage={images} setImageIndexData={imageIndexData} />
          <Textarea className="textarea-wrap" id="contents" value={contents} placeholder="A/S 건에 대해 자세히 설명해주세요!" onChange={handleTextarea} />
        </WriteWrap>
      </Body>
    </>
  );
}

const TitleBox = styled.div`
  padding: 40px 15px 0;
  margin-bottom: 15px;
  .title {
    color: #000;
    font-weight: 700;
    font-size: 18px;
  }
  .date {
    padding: 10px 0 15px;
    border-bottom: 2px solid #000;
    color: #818181;
    font-family: "Poppins";
    font-weight: 400;
  }
`;

const WriteWrap = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin("column", "space-between", "stretch")}
  height: calc(100% - 60px);
  padding: 0 15px;
  .input-file {
    flex-basis: 75px;
  }
  .textarea-wrap {
    flex: 1;
  }
`;

export default reportRegister;
